import moment from 'moment';

import { DATE_FORMAT } from '../../../constants/orders/date-format';

export const calcAndFormatDate = pastDays =>
  moment()
    .subtract(pastDays, 'days')
    .format(DATE_FORMAT);
